package io.horion.auth.domain.models

enum class Countries(val code: String) {
    CMR("CMR +237")
}